export default function Overview() {
  return (
    <section id="overview" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="flex items-center mb-4">
              <i className="ri-file-text-line text-[#e10708] text-xl mr-2 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-[#e10708] text-sm uppercase tracking-widest font-light">
                Understanding SB 2610
              </span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-serif text-[#1A1F2E] leading-tight mb-6">
              What is Texas<br />
              Senate Bill 2610?
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              Texas Senate Bill 2610 mandates comprehensive cybersecurity measures for law firms and legal service providers handling sensitive client information. The law requires specific technical safeguards to protect attorney-client privileged communications and confidential legal data.
            </p>

            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Effective September 1, 2025, all Texas law firms must implement documented cybersecurity programs that meet state-mandated standards. Non-compliance can result in penalties exceeding $500,000 and potential liability for data breaches.
            </p>

            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#e10708]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-[#e10708] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="text-[#1A1F2E] font-bold mb-1">Mandatory Compliance</h3>
                  <p className="text-gray-600 text-sm">
                    All Texas law firms handling client data must comply with SB 2610 cybersecurity requirements.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#e10708]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-alert-line text-[#e10708] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="text-[#1A1F2E] font-bold mb-1">Severe Penalties</h3>
                  <p className="text-gray-600 text-sm">
                    Non-compliance can result in fines up to $500,000 plus liability for breaches and professional sanctions.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#e10708]/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-time-line text-[#e10708] text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h3 className="text-[#1A1F2E] font-bold mb-1">Ongoing Requirements</h3>
                  <p className="text-gray-600 text-sm">
                    Annual risk assessments, continuous monitoring, and regular staff training are required to maintain compliance.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[600px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/b5b66881cd8feeece1f6a1f83e754349.jpg"
                  alt="Legal Compliance"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-xl shadow-2xl p-6 border border-gray-200 max-w-xs">
              <div className="flex items-center mb-3">
                <i className="ri-bar-chart-line text-[#e10708] text-2xl mr-3 w-6 h-6 flex items-center justify-center"></i>
                <h4 className="text-[#1A1F2E] font-bold">Compliance Impact</h4>
              </div>
              <p className="text-gray-600 text-sm mb-4">
                Law firms with comprehensive cybersecurity programs experience 87% fewer data breaches and maintain stronger client trust.
              </p>
              <div className="flex items-center text-[#e10708] text-sm font-semibold">
                <span>Learn how we help</span>
                <i className="ri-arrow-right-line ml-2 w-4 h-4 flex items-center justify-center"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}